import {
	ADMINGETRISKRULEMAPPING_SUCCESS,
	ADMINGETRISKRULEMAPPING_FAILED,
	RESET_ADMINGETRISKRULEMAPPING,
	LOADING_ADMINGETRISKRULEMAPPING,
	NETWORK_ERROR_ADMINGETRISKRULEMAPPING
} from "../types/index";

const initialState = {
	isLoading: false,
	success: false,
	network: false,
	failed: false,
	data: {},
	message: "",
	networkError: ""
};

export default (state = initialState, action) => {
	switch (action.type) {
		case LOADING_ADMINGETRISKRULEMAPPING:
			return {
				...state,
				isLoading: true,
				success: false,
				failed: false,
				network: false,
				data: {},
				message: "",
				networkError: ""
			};
		case ADMINGETRISKRULEMAPPING_FAILED:
			return {
				...state,
				isLoading: false,
				success: false,
				failed: true,
				network: false,
				data: action.payload,
				message: "",
				networkError: ""
			};
		case ADMINGETRISKRULEMAPPING_SUCCESS:
			return {
				...state,
				isLoading: false,
				success: true,
				failed: false,
				network: false,
				data: action.payload,
				message: "",
				networkError: ""
			};
		case NETWORK_ERROR_ADMINGETRISKRULEMAPPING:
			return {
				...state,
				isLoading: false,
				success: false,
				failed: false,
				network: true,
				data: {},
				message: "",
				networkError: ""
			};
		case RESET_ADMINGETRISKRULEMAPPING:
			return (state = initialState);
		default:
			return state;
	}
};
